import React from "react";
import { Link } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const newArrivals = productData.slice(0, 4);

  return (
    <div className="main">
      <main>
        {/* Grid 1 */}
        <div className="hero-grid">
          <div className="hero-item">
            <img src="/main/ovh-new-arrivals.png" alt="Ovahorizon new arrivals campaign" />
            <div className="hero-content">
              <span className="hero-title">NEW ARRIVALS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
          <div className="hero-item">
            <img src="/main/ovh-dresses.png" alt="Ovahorizon dresses campaign" />
            <div className="hero-content">
              <span className="hero-title">DRESSES</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
        </div>

        {/* Grid 2 */}
        <div className="hero-grid">
          <div className="hero-item">
            <img src="/main/ovh-skirts.png" alt="Ovahorizon skirts campaign" />
            <div className="hero-content">
              <span className="hero-title">SKIRTS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
          <div className="hero-item">
            <img src="/main/ovh-tops.png" alt="Ovahorizon tops and T-shirts campaign" />
            <div className="hero-content">
              <span className="hero-title">TOPS AND T-SHIRTS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
        </div>

        {/* Shop New Arrivals Section */}
        <div className="new-arrivals-section">
          <h2 className="section-title">SHOP NEW ARRIVALS</h2>
          <div className="product-grid">
            {newArrivals.map((product, index) => (
              <div className="product-card" key={product.id}>
                <div className="image-container">
                  <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                    <img 
                      src={product.homeImage} 
                      alt={product.name} 
                    />
                  </Link>
                  <Link to={`/shopDetails/${product.id}`} onClick={toTop} className="add-to-cart-btn" aria-label="View product details">
                    <FiShoppingBag size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Grid 3 */}
        <div className="hero-grid">
          <div className="hero-item">
            <img src="/main/ovh-sets.png" alt="Ovahorizon matching sets campaign" />
            <div className="hero-content">
              <span className="hero-title">MATCHING SETS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
          <div className="hero-item">
            <img src="/main/ovh-jeans.png" alt="Ovahorizon jeans campaign" />
            <div className="hero-content">
              <span className="hero-title">JEANS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
        </div>

        {/* Grid 4 */}
        <div className="hero-grid">
          <div className="hero-item">
            <img src="/main/ovh-frame.png" alt="Ovahorizon Beyond the Frame campaign" />
            <div className="hero-content">
              <span className="hero-title">BEYOND THE FRAME</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
          <div className="hero-item">
            <img src="/main/ovh-campaign.png" alt="Ovahorizon seasonal campaign" />
            <div className="hero-content">
              <span className="hero-title">OUR CAMPAIGNS</span>
              <Link to="/shop" className="hero-link" onClick={toTop}>SHOP NOW</Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Main;
